import styled from 'styled-components';

export const Image = styled.img`
  display: block;
  width: 100%;
  height: auto;
  /* The screens are windows with an alpha channel (rounded corners, and for
     the terminal transparent sides). drop-shadow follows that alpha, so the
     window sits on the light page without a box or ragged edges; the pixels
     themselves are untouched. */
  filter: drop-shadow(0 12px 24px rgba(15, 33, 55, 0.18))
    drop-shadow(0 0 1px rgba(15, 33, 55, 0.4));
`;
